// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/x-mark.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'x-mark',
  version: 'outline',
  paths: [
    {
      d: 'M6 18 18 6M6 6l12 12',
    },
  ],
}
